function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.93,
    height: 10.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 5.075
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.15,
    width: 24.93,
    height: 21.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.70625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 20.975
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.8,
    width: 24.93,
    height: 26.34,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 44.97
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.13,
    width: 24.93,
    height: 29.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 72.64
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87.15,
    width: 24.93,
    height: 37.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 105.97500000000001
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 124.8,
    width: 24.93,
    height: 40.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 145.09
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.38,
    width: 24.93,
    height: 45.18,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5614285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 187.97
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.56,
    width: 24.93,
    height: 46.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5614285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 233.965
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.37,
    width: 24.93,
    height: 48.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 281.68
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306,
    width: 24.93,
    height: 50.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 331.34
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.68,
    width: 24.93,
    height: 54.16,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 383.76
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.84,
    width: 24.93,
    height: 55.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 438.37
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.9,
    width: 24.93,
    height: 56.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 494.32
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.74,
    width: 24.93,
    height: 57.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 551.71
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.68,
    width: 24.93,
    height: 59.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 610.4699999999999
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.26,
    width: 24.93,
    height: 59.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.465,
    y: 670.13
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 0,
    width: 37.01,
    height: 43.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7009999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.435,
    y: 21.625
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.94,
    y: 0,
    width: 37.49,
    height: 43.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.248333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 21.625
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.43,
    y: 0,
    width: 38.02,
    height: 43.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.44000000000001,
    y: 21.625
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.44,
    y: 0,
    width: 41.34,
    height: 43.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.134
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.11,
    y: 21.625
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.78,
    y: 0,
    width: 42.7,
    height: 43.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.13,
    y: 21.625
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.48,
    y: 0,
    width: 42.86,
    height: 43.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.91,
    y: 21.625
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.34,
    y: 0,
    width: 42.88,
    height: 43.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.78,
    y: 21.625
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.23,
    y: 0,
    width: 44.25,
    height: 43.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.178571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.355,
    y: 21.625
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.48,
    y: 0,
    width: 46.14,
    height: 43.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.55,
    y: 21.625
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.62,
    y: 0,
    width: 47.05,
    height: 43.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.178571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.145,
    y: 21.625
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.68,
    y: 0,
    width: 48.75,
    height: 43.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.055,
    y: 21.625
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.43,
    y: 0,
    width: 49.24,
    height: 43.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.05,
    y: 21.625
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.67,
    y: 0,
    width: 49.41,
    height: 43.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.375,
    y: 21.625
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.09,
    y: 0,
    width: 53.21,
    height: 43.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.695,
    y: 21.625
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.3,
    y: 0,
    width: 54.7,
    height: 43.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.65,
    y: 21.625
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 43.25,
    width: 33.43,
    height: 74.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.571666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 80.60499999999999
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 117.96,
    width: 33.43,
    height: 75.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.039090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 155.47
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 192.97,
    width: 33.43,
    height: 76.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.714444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 231.165
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 269.37,
    width: 33.43,
    height: 79.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 309.065
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 348.76,
    width: 33.43,
    height: 85.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 391.44
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 434.12,
    width: 33.43,
    height: 85.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 476.82
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 519.52,
    width: 33.43,
    height: 89.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.785833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 564.3249999999999
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 609.13,
    width: 33.43,
    height: 90.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.571666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.644999999999996,
    y: 654.565
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 43.25,
    width: 65.42,
    height: 70.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.06,
    y: 78.50999999999999
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.77,
    y: 43.25,
    width: 66.48,
    height: 70.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.01,
    y: 78.50999999999999
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.25,
    y: 43.25,
    width: 70.3,
    height: 70.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.4,
    y: 78.50999999999999
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.56,
    y: 43.25,
    width: 74.09,
    height: 70.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.052
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.605,
    y: 78.50999999999999
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.65,
    y: 43.25,
    width: 77.88,
    height: 70.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.41090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.59,
    y: 78.50999999999999
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.53,
    y: 43.25,
    width: 95.12,
    height: 70.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.09,
    y: 78.50999999999999
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.65,
    y: 43.25,
    width: 96.02,
    height: 70.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.074285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.66,
    y: 78.50999999999999
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.67,
    y: 43.25,
    width: 96.33,
    height: 70.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.753333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.8349999999999,
    y: 78.50999999999999
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 113.77,
    width: 94.48,
    height: 71.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 149.755
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 185.74,
    width: 94.48,
    height: 80.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 225.995
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 266.25,
    width: 94.48,
    height: 83.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.45875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 308.085
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 349.92,
    width: 94.48,
    height: 84.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.030000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 392.01
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 434.1,
    width: 94.48,
    height: 113.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.746666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 490.615
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 547.13,
    width: 94.48,
    height: 152.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.59,
    y: 623.565
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.83,
    y: 113.77,
    width: 162.07,
    height: 140.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.865,
    y: 184.07
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.9,
    y: 113.77,
    width: 180.16,
    height: 140.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.119999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.97999999999996,
    y: 184.07
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.06,
    y: 113.77,
    width: 204.94,
    height: 140.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.781818181818181
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.53,
    y: 184.07
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.83,
    y: 254.37,
    width: 153.64,
    height: 221.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.65,
    y: 364.915
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.83,
    y: 475.46,
    width: 153.64,
    height: 224.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.948571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.65,
    y: 587.73
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.47,
    y: 254.37,
    width: 168.62,
    height: 204.84,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.78000000000003,
    y: 356.79
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.09,
    y: 254.37,
    width: 224.91,
    height: 204.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 40.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.545,
    y: 356.79
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.47,
    y: 459.21,
    width: 195.63,
    height: 240.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.285,
    y: 579.605
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.1,
    y: 459.21,
    width: 197.9,
    height: 240.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.0500000000001,
    y: 579.605
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.cdc5f47168c78d8b96bf038662cf1a82.svg";
export { ForwardRef as ReactComponent };